<template>
    <div>
        <div class="one">
            <div class="form-floating">
                <input  type="text" class="form-control" id="floatingInput" :placeholder="$t('company.nazovslug_text_1')" 
                        v-model="firma" />
                <label for="floatingInput">{{ $t('company.nazovslug_text_1') }}</label>
                <div class="info">
                    <div class="my_tooltip">{{ $t('company.nazovslug_text_2') }}</div>
                    <div class="tooltip_hover info_icon">
                        <img src="/img/info_icon.svg" alt="">
                    </div>
                </div>
            </div>
        </div>
        <div v-show="has_slug" class="one mt-3 ml-1">
            <div class="odkaz">
                <div class="odkaz_text">
                    {{ $t('company.nazovslug_text_3') }}
                </div>
                <div class="bottom">
                    <div class="odkaz_web">
                        www.doffero.com/ID_ponuky/
                    </div>
                    <input type="text" v-model="slug">
                </div>
            </div>
        </div>
        <div v-if="this.error" class="error">
            <svg width="17" height="15" viewBox="0 0 17 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.5586 12.8086L9.99609 1.40625C9.50391 0.558594 8.21875 0.53125 7.72656 1.40625L1.16406 12.8086C0.671875 13.6562 1.30078 14.75 2.3125 14.75H15.4102C16.4219 14.75 17.0508 13.6836 16.5586 12.8086ZM8.875 10.4297C9.55859 10.4297 10.1328 11.0039 10.1328 11.6875C10.1328 12.3984 9.55859 12.9453 8.875 12.9453C8.16406 12.9453 7.61719 12.3984 7.61719 11.6875C7.61719 11.0039 8.16406 10.4297 8.875 10.4297ZM7.67188 5.91797C7.64453 5.72656 7.80859 5.5625 8 5.5625H9.72266C9.91406 5.5625 10.0781 5.72656 10.0508 5.91797L9.85938 9.63672C9.83203 9.82812 9.69531 9.9375 9.53125 9.9375H8.19141C8.02734 9.9375 7.89062 9.82812 7.86328 9.63672L7.67188 5.91797Z" fill="#DB355F"/>
            </svg>
            {{this.error}}
        </div>
    </div>
</template>


<script>
export default {
    props: ['company','companies'],
    data() {
        return {
            has_slug: false,
            firma: "",
            slug: "",
            error: "",
            iserror: false,
            next: false
        };
    },
    created () {
        this.firma = this.company.firma
        this.slug = this.company.slug
    },
    methods: {
        saveform() {
            let err = false
            if(this.firma == ""){
                this.error = "Prosím vyplň názov firmy alebo značky."
                return
            }
            this.companies.forEach(company => {
                if(company.slug == this.slug){
                    this.error = "Takýto odkaz už niekto používa. Skús použiť iný."
                    err = true
                }
            })
        },
        saveSlug(value) {
            return value
            .toString()
            .toLowerCase()
            .replace(/\s+/g, "-") // Replace spaces with -
            .replace(/[^\w\-]+/g, "") // Remove all non-word chars
            .replace(/\-\-+/g, "-") // Replace multiple - with single -
            .replace(/^-+/, "") // Trim - from start of text
            .replace(/-+$/, "");
        },
        resetSlug() {
            this.isEditing = false;
            this.slug = this.saveSlug(this.firma);
        }
    },
    watch: {
        slug: function(){
            let width = this.slug.length * 10;
            $('.odkaz input').css('width', width);
            this.iserror = false
            this.companies.forEach(company => {
                if(company.id != this.id){
                    if(company.slug == this.slug){
                        this.iserror = true
                    }
                }
            });
            if(this.iserror)
                this.error = "Takýto odkaz už niekto používa. Skús použiť iný."
            else
                this.error = ""

            let data = {
                firma: this.firma,
                slug: this.slug,
                error: this.iserror
            }
            this.$emit('data', data);
        },
        firma: function() {
            if(this.firma != ""){
                this.has_slug = true
                this.iserror = false
                this.error = ""
                this.slug = this.saveSlug(this.firma);
            }
            else{
                this.iserror = true
                this.error = "Prosím vyplň názov firmy alebo značky."
                this.has_slug = false
                let data = {
                    firma: this.firma,
                    slug: this.slug,
                    error: this.iserror
                }
                this.$emit('data', data);
            }
                

        }

    },
};
</script>

<style lang="scss" scoped>
    .error{
        width: 473px;
        height: 60px;
        margin: 15px auto;
        background: #FFEBEE;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;

        font-family: Roboto;
        font-style: normal;
        font-weight: 800;
        font-size: 14px;
        line-height: 182.5%;
        color: #DB355F;
        svg{
            margin-right: 10px;
        }
    }
    .one{
        .form-floating{
            width: 430px;
            height: 55px;
            margin: 0 auto;
            @media only screen and (max-width: 600px) {
                width: 95%;
            }
            input{
                display: flex !important;
                align-items: center !important;
                background: #FFFFFF;
                border: 1px solid #DDE3E8;
                box-sizing: border-box;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 14px;
                line-height: 16px;
                display: flex;
                align-items: center;
                color: #212541;
                padding-left: 23px;
            }
            label{
                display: flex !important;
                align-items: center !important;
                font-family: Roboto;
                font-style: normal;
                font-weight: bold;
                font-size: 12px;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: #9598A7;
                padding-left: 23px;
            }
            .resetslug{
                position: absolute;
                right: -25px;
                top: 0;
                bottom: 0;
                margin: auto;
                height: 20px;
            }
        }
        .odkaz{
            width: 430px;
            margin: 0 auto;
            @media only screen and (max-width: 600px) {
                width: 90%;
            }
            .odkaz_text{
                font-family: Roboto;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 150%;
                color:#9598A7;

            }
            .bottom{
                margin-top: 7px;
                display: flex;
                align-items: center;
                .odkaz_web{
                    font-family: Roboto;
                    font-style: normal;
                    font-weight: normal;
                    font-size: 14px;
                    line-height: 16px;
                    color: #9598A7;;
                }
                input{
                    font-family: Roboto;
                    font-style: normal;
                    font-weight: bold;
                    font-size: 14px;
                    line-height: 16px;
                    color: #212541;
                    background: transparent;
                    border: none;
                    border-bottom: 0.15rem solid;
                    width: 150px;
                }
                .resetslug{
                    margin-left: 5px;
                }
            }

        
        }

    }
    
.info{
    position: absolute;
    height: 20px;
    top: 16px;
    right: 11px;
    .info_icon{
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;
        img{
            width: 80%;
            height: 80%;
        }
    }
    .my_tooltip{
        bottom: 22px;
        right: -7px;
    }
    &:hover{
        .my_tooltip{
            opacity: 1;
        }
    }
}
.agree_tooltip{
    position: relative;
}
.my_tooltip{
    font-family: Roboto;
    font-style: normal;
    font-weight: 600;
    pointer-events: none;
    opacity: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 300px;
    background: #F3385A;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 14px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10000;
    transition: opacity .5s ease-in-out;
    &::after{
        content: '';
        width: 15px;
        height: 15px;
        background: #F3385A;
        position: absolute;
        right: 10px;
        bottom: -3px;
        transform: rotate(45deg);
        border-radius: 3px;
    }
}
</style>